import React, { useEffect, useState, JSX, ChangeEvent } from 'react'
import { IntlShape, useIntl, FormattedMessage } from 'react-intl';
import ClipLoader from "react-spinners/ClipLoader";
import ApiFailed from '../../Utils/ApiFailed';
import FullWidthMobileButton from '../../components/FullWidthMobileButton';
import { DataGrid, Column, Export, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring, HeaderFilter, DataGridTypes } from 'devextreme-react/data-grid';
import Modal from 'react-bootstrap/Modal'
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import IconButton from '@mui/material/IconButton';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { CreateUrl, CallGetAPI, CallPutAPI, CallDeleteAPI } from 'Utils/ApiHelper.js';
import { adjustTime } from '../../Utils/AdjustTime'
import Menu from '@mui/material/Menu';
import { MenuItem, Select } from '@mui/material';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { useMobileLandscape } from '../../Context/ContextProvider'
import Loader from '../../Utils/Loader/NewLoader2025'
import deMessages from "devextreme/localization/messages/de.json";
import frMessages from "devextreme/localization/messages/fr.json";
import esMessages from "devextreme/localization/messages/es.json";
import ptMessages from "devextreme/localization/messages/pt.json";
import { locale, loadMessages } from "devextreme/localization";
interface Props {
    classes: {
        cardTitleWhite: string;
        formControl: string;
        cardCategoryWhite: string;
    };
    history: {
        goBack: () => void;
    };
}

interface Company {
    calcMNF: boolean
    companyGUID: string
    contactEmail: string
    endTimeMNF: Date
    id: number
    isSummerTime: boolean
    name: string
    parentId: number | null
    startTimeMNF: Date
    utcOffset: number
}

interface User {
    canConfig: boolean | undefined
    created: string
    dashboardJson: null
    email: string
    favourites: string
    filterGroup: number
    firstLogin: boolean
    fkCompany: Company
    flowUnits: string
    graphTotaliser: boolean
    id: number
    inactiveTimeframe: string
    language: string
    lastLogin: string | Date
    level: string
    lockout: boolean | string
    userGUID: string
    utcOffset: number
}


const UsersMobile: React.FC<Props> = ({ classes, history }) => {
    const intl:IntlShape = useIntl()
    const isLandscape = useMobileLandscape()

    const [loading, setLoading] = useState<boolean>(false)
    const [tableHidden, setTableHidden] = useState<boolean>(false)
    const [userData, setUserData] = useState<Array<User>>([])
    const [anchorEl, setAnchorEl] = useState<EventTarget & HTMLElement | null>(null)
    const [tempUser, setTempUser] = useState<User | undefined>()
    const [passwordModal, setPasswordModal] = useState<boolean>(false)
    const [modal, setModal] = useState<boolean>(false)
    const [modalTitle, setModalTitle] = useState<string>("")
    const [editUserDetails, setEditUserDetails] = useState<boolean>(false)
    const [originalUser, setOriginalUser] = useState<string>("")
    const [deleteModal, setDeleteModal] = useState<boolean>(false)
    locale(sessionStorage.getItem('language'));
    loadMessages(frMessages);
    loadMessages(deMessages);
    loadMessages(esMessages);
    loadMessages(ptMessages);


    useEffect(() => {
        reloadData(null)
    }, [])



   const reloadData = (editId: number | null): void => {

        CallGetAPI(CreateUrl('/api/aquaguard/Users?companyId=' + sessionStorage.getItem('companyId')), {})
            .then(data => {
                if (data.length > 0) {
                    // Copy the data records into deviceData, adding the clickEvent
                    console.log(data)


                    data.forEach((d: User) => {
                        d.lockout = d.lockout ? 'Locked Out' : ''
                        d.lastLogin = d.lastLogin !== null  ? adjustTime(d.lastLogin) : intl.formatMessage({ id: "No Login" })
                    })

                    setTableHidden(false)
                    setLoading(false)
                    setUserData(data)
                }
                else {
                            setTableHidden(false)
                            setLoading(false)
                }
            })
            .catch(function (err:string) {
                console.error(err)
            });


    }

    const moreRender = (data: DataGridTypes.ColumnCellTemplateData): JSX.Element => {
        return (
            <IconButton size="small" onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => { handleClick(e, data.data.id); }}><MoreHorizIcon /></IconButton>
        );
    }

    const handleClick = (e: React.MouseEvent<HTMLElement>, id: number): void => {
        const user: User | null | undefined = userData.find(u => u.id === id)
        setAnchorEl(e.currentTarget)
        setTempUser(user)
        console.log(id)

    }

    const handleClose = ():void => {
        setAnchorEl(null)
    }

    const toggleModal = (): void => {
        setModal(!modal)
        setAnchorEl(null)
    }

    const editUser = (): void => {
        setEditUserDetails(true)
        setModal(!modal)
        setAnchorEl(null)
        setModalTitle(intl.formatMessage({ id: "Edit User" }))
        if (tempUser) {
            setOriginalUser(tempUser.email)
        }
    }


    const userNameChanged = (event: any): void => {
        if (tempUser) {
            const tempUserTemp: User = { ...tempUser };
            tempUserTemp.email = event.target.value;
            setTempUser(tempUserTemp)
        }
    }
    const userLevelChanged = (e: ChangeEvent<HTMLSelectElement> ): void => {
        if (tempUser) {
            const tempUserTemp:User = { ...tempUser };
            tempUserTemp.level = e.target.value;
            console.log(tempUserTemp)
            setTempUser(tempUserTemp)
        }
        
    }


    const userLockoutChanged = (event: any): void => {
        if (tempUser) {
            const tempUserTemp: User = { ...tempUser };
            tempUserTemp.lockout = event.target.checked ? event.target.value : '';
            setTempUser(tempUserTemp)
        }
    }

    const userConfigChanged = (event: any): void => {
        if (tempUser) {
            const tempUserTemp:User = { ...tempUser };
            tempUserTemp.canConfig = event.target.checked;
            setTempUser(tempUserTemp)
        }
    }

    const createSuccessNotification = (): void => {
        NotificationManager.success(intl.formatMessage({ id: 'Saved Changes' }), intl.formatMessage({ id: 'Success' }))

    };

    const createFailedInsertErrorNotification = (): void => {
        NotificationManager.error(intl.formatMessage({ id: 'Error creating new record' }), '', 5000);
    };

    const createErrorNotification = (): void => {
        NotificationManager.error(intl.formatMessage({ id: 'Error Saving Changes' }), intl.formatMessage({ id: 'Contact Administrator' }), 5000, () => {
            alert(intl.formatMessage({ id: 'Contact Administrator' }));
        });
    };

    const saveUser = ():void => {
        let canConfig = false

        if (tempUser?.level === 'useradmin') {
            canConfig = true
        } else if (tempUser?.level === 'restricted') {
            canConfig = false
        } else if (tempUser?.level === 'user') {
            canConfig = tempUser.canConfig
        }
        const tempUserTemp = { ...tempUser }
        tempUserTemp.canConfig = canConfig
        setTempUser(tempUserTemp)

        if (editUserDetails === false) { //adding a new User


                setModal(false)
                setLoading(true)

            //********************
            //send model to API

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Username: tempUser?.email,
                    CompanyGuid: tempUser?.fkCompany.companyGUID,
                    Level: tempUser?.level,
                    CanConfig: canConfig,

                })
            };
            let apiURLroot = '';
            if (tempUser?.level === 'user') apiURLroot = '/api/aquaguard/User';
            if (tempUser?.level === 'useradmin') apiURLroot = '/api/aquaguard/AdminUser';

            CallGetAPI(CreateUrl(apiURLroot), requestOptions)
                .then(data => {
                    console.log(data)
                    createSuccessNotification()
                    toggleModal();
                    setTimeout(() => { reloadData(null) }, 500)
                    
                })

                .catch(function (error) {
                    createFailedInsertErrorNotification();
                    console.error(error)
                    toggleModal();
                    setLoading(false)
                });

        }
        else {//modifying an existing User

            //********************
            //send model to API

            //save User
            const requestOptions = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    username: originalUser,
                    newUsername: tempUser?.email,
                    userLevel: tempUser?.level,
                    lockedout: tempUser?.lockout == "Locked Out",
                    canConfig: canConfig
                })
            };

            CallPutAPI(CreateUrl('/api/Aquaguard/User/' + tempUser?.id), requestOptions)
                .then(async response => {
                    if (response.status == 204) {
                        console.log('hit status 204')
                        createSuccessNotification()
                        setTimeout(() => { reloadData(null) }, 500)

                        setModal(!modal)
                        setLoading(false)
                        
                    }
                    else {
                        toggleModal()
                        setLoading(false)
                    }


                })
                .catch(function (error) {
                    createErrorNotification()
                    toggleModal()
                    console.error(error)
                    setLoading(false)
                });

        }
        reloadData(null)
    }

    const cancel = () => {
        setModal(!modal)
        setTempUser(undefined)
    }

    const togglePasswordModal = ():void => {
        setPasswordModal(!passwordModal)
        setAnchorEl(null)
        setModalTitle(intl.formatMessage({ id: "Password Reset" }))
    }


    const resetPassword = ():void => {

        //reset user's password

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                UserId: tempUser?.id,
                UserGuid: tempUser?.userGUID,
                newPassword: "Passw0rd!",
                oldPassword: "",
            })
        };

        CallGetAPI(CreateUrl('/api/aquaguard/UserPassword'), requestOptions)
            .then(() => {
                createSuccessNotification();
                setPasswordModal(!passwordModal)
            },
            // Reject
            () => {
                createErrorNotification()
                setPasswordModal(!passwordModal)
            })
            .catch(function (error) {
                createErrorNotification();
                console.error(error);
                setPasswordModal(!passwordModal)
            });
    }

    const toggleDeleteModal = ():void => {
        setAnchorEl(null)
        setDeleteModal(!deleteModal)
        setModalTitle(intl.formatMessage({ id: "Warning" }))
    }


    const deleteRow = ():void => {

        //delete from database

        CallDeleteAPI(CreateUrl('/api/Aquaguard/User?id=' + tempUser?.id), {})
            .then(async response => {
                if (response.ok) {
                    createSuccessNotification()
                }
                toggleDeleteModal();
            })
            .catch(function (error) {
                createErrorNotification()
                console.error(error)
            });
        setTimeout(() => {
            reloadData(null)
        }, 750)
    }

    return (
        <div>
            {loading && 
                <div style={{
                    position: 'relative', left: 'Calc(50% - 100px)', top: 'Calc(50vh - 200px)'
                }}>
                    <Loader color={undefined} />
            </div>}
            {!loading && <div>
                {tableHidden && <ApiFailed />}
                {!tableHidden && 
                    <div>
                        <Modal
                            show={passwordModal}
                            onHide={(): void => togglePasswordModal()}
                            dialogClassName="modal-100w"
                            aria-labelledby="example-custom-modal-styling-title"
                            centered
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="example-custom-modal-styling-title">
                                    {modalTitle}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="show-grid">
                                <p>{`${intl.formatMessage({ id: "User" })} ${tempUser?.email} ${intl.formatMessage({ id: "will have password reset to" })}`} <b>Passw0rd!</b> {`${intl.formatMessage({ id: "and be required to reset a secure password when they next login." })}`}</p>
                                <p>{intl.formatMessage({ id: "Do you want to continue?" })}</p>
                            </Modal.Body>
                            <Modal.Footer>
                                <FullWidthMobileButton disabled={false} color="primary" onClick={(): void => resetPassword()} text={intl.formatMessage({ id: "Continue" })} />
                                <div style={{marginTop: 10, width: "100%"} }>
                                    <FullWidthMobileButton disabled={false} color="error" onClick={(): void => togglePasswordModal()} text={intl.formatMessage({ id: "Cancel" })} />
                                </div>
                            </Modal.Footer>
                        </Modal>
                        <Modal
                            show={deleteModal}
                            onHide={(): void => toggleDeleteModal()}
                            dialogClassName="modal-100w"
                            aria-labelledby="example-custom-modal-styling-title"
                            centered
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="example-custom-modal-styling-title">
                                    {modalTitle}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="show-grid">
                                {intl.formatMessage({ id: "Delete user?" })}
                            </Modal.Body>
                            <Modal.Footer>
                                <FullWidthMobileButton color="primary" onClick={(): void => deleteRow()} text={intl.formatMessage({ id: "Continue" })} disabled={false} />
                                <div style={{ marginTop: 10, width: "100%" }}>
                                    <FullWidthMobileButton color="error" onClick={(): void => toggleDeleteModal()} text={intl.formatMessage({ id: "Cancel" })} disabled={false} />
                                </div>
                            </Modal.Footer>
                        </Modal>
                        <Modal
                            show={modal}
                            onHide={(): void => toggleModal()}
                            dialogClassName="modal-100w"
                            aria-labelledby="example-custom-modal-styling-title"
                            centered
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="example-custom-modal-styling-title">
                                    {modalTitle}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="show-grid">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} >

                                        <div style={{ padding: 10 }}>
                                            <p><FormattedMessage id="Email Address" />:</p>
                                            <TextField
                                                id="outlined-input"
                                                label={intl.formatMessage({ id: "Name (Email)" })}
                                                value={tempUser?.email}
                                                onChange={userNameChanged}
                                                variant="outlined"
                                                style={{ width: "100%" }}
                                            />
                                        </div>
                                    </Grid>
                                   
                                    <Grid item xs={12} >
                                        <div style={{ padding: 10 }}>
                                            <p><FormattedMessage id="User Level" />:</p>
                                            <Select
                                                id="outlined-select"
                                                label={intl.formatMessage({ id: "Level" })}
                                                value={tempUser?.level}
                                                onChange={(e):void => userLevelChanged(e)}
                                                variant="outlined"
                                                size='small'
                                                fullWidth

                                            >
                                                <MenuItem value="user">{intl.formatMessage({ id: "User" })}</MenuItem>
                                                {sessionStorage.getItem('userLevel') === 'useradmin' && <MenuItem value="useradmin">{intl.formatMessage({ id: "User Admin" })}</MenuItem>}
                                                {editUserDetails && <MenuItem value="restricted">{intl.formatMessage({ id: "Restricted" })}</MenuItem>}
                                            </Select>
                                        </div>
                                    </Grid>

                                    <Grid item xs={12} >
                                        <div style={{ padding: 10, display: 'flex', flexDirection: 'column' }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        id="outlined-checkbox"
                                                        value="Locked Out"
                                                        checked={tempUser?.lockout == "Locked Out"}
                                                        onChange={userLockoutChanged}
                                                    />
                                                }
                                                label={intl.formatMessage({ id: "Locked Out" })}
                                            />
                                            {console.log(tempUser) }
                                            {tempUser?.level !== 'useradmin' && tempUser?.level !== 'restricted' && <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        id="outlined-checkbox"
                                                        value={tempUser?.canConfig}
                                                        checked={tempUser?.canConfig}
                                                        onChange={userConfigChanged}
                                                    />
                                                }
                                                label={intl.formatMessage({ id: "Allow user to configure loggers" })}
                                            />}
                                        </div>
                                    </Grid>
                                </Grid>
                            </Modal.Body>
                            <Modal.Footer>
                                <FullWidthMobileButton text={editUserDetails ? intl.formatMessage({ id: "Update User" }) : intl.formatMessage({ id: "Add User" })} disabled={false} color="primary" onClick={():void => saveUser()} />
                                <div style={{marginTop: 10, width: "100%", padding: 0} }>
                                    <FullWidthMobileButton text={"Cancel"} disabled={false} color="error" onClick={(): void => cancel()} />
                                </div>
                            </Modal.Footer>
                        </Modal>
                    <div style={{ width: isLandscape ? '100%' : "118%", transform: isLandscape ? 'translateX(0)' : "translateX(-8%)" }}>
                        <Card>
                            <CardHeader color="primary" className="view view-cascade  d-flex justify-content-between align-items-center py-2 mx-4 mb-3">
                                <h4 style={{ textAlign: "center", marginLeft: "10px" }}>Manage Users</h4>
                            </CardHeader>
                                <CardBody>
                                    
                                <DataGrid
                                    dataSource={userData}>
                                    <StateStoring enabled={true} type="localStorage" storageKey="UserListGrid" />
                                    <FilterRow visible={true} />
                                    <GroupPanel visible={true} />
                                    <Grouping autoExpandAll={true} />
                                    <HeaderFilter visible={true} />
                                        <Column dataField="email" dataType="string" caption={intl.formatMessage({ id: "User Name" })} />
                                        <Column dataField="level" dataType="string" width={80} caption={intl.formatMessage({ id: "Level" })} />
                                        <Column fixed={true} fixedPosition='right' type="buttons" cellRender={(e): React.ReactNode => moreRender(e)} width={50} />
                                </DataGrid>
                            </CardBody>
                        </Card>

                        </div>
                    </div>
                }
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    disableScrollLock={true}
                >
                    <MenuItem onClick={():void => editUser()}>{intl.formatMessage({ id: "Edit" })}</MenuItem>
                    <MenuItem onClick={(): void => togglePasswordModal()}>{intl.formatMessage({ id: "Force password reset" })}</MenuItem>
                    <MenuItem onClick={():void => toggleDeleteModal()}>{intl.formatMessage({ id: "Delete" })}</MenuItem>
                </Menu>
                <NotificationContainer />
            </div>

            }
        </div>
    )
}
export default UsersMobile